import React from 'react';
import { useTranslation } from 'react-i18next';
import IconBoxStyle11 from '../../IconBox/IconBoxStyle11';
import Spacing from '../../Spacing';

export default function ContactInfoSection({ sectionTitle }) {
  const { t } = useTranslation();
  return (
    <div className="container">
      <h2 className="cs_fs_72 mb-0">{sectionTitle}</h2>
      <Spacing md="70" lg="50" />
      <div className="row g-4 g-xl-3 g-xxl-5">
        <div className="col-xl-4">
          <IconBoxStyle11
            title={t('home.heroInfo.phone')}
            subTitle={t('footer.contact.phone')}
            iconSrc="/images/contact/icon_1.svg"
          />
        </div>
        <div className="col-xl-4">
          <IconBoxStyle11
            title={t('home.heroInfo.email')}
            subTitle={t('footer.contact.email')}
            iconSrc="/images/contact/icon_2.svg"
          />
        </div>
        <div className="col-xl-4">
          <IconBoxStyle11
            title={t('home.heroInfo.address')}
            subTitle={`${t('footer.contact.addressLine1')}`}
            iconSrc="/images/contact/icon_3.svg"
          />
        </div>
      </div>
      <Spacing md="35" />
      {/* Start Google Map */}
      <div className="cs_map">
        <iframe
          id="map"
          title="Google Map"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3858.5842681123113!2d-17.44454932489117!3d14.736080785766488!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xec1736ef021124b%3A0x91d616006214b3da!2sTransvie!5e0!3m2!1sfr!2ssn!4v1757955419672!5m2!1sfr!2ssn"
          allowFullScreen
        />
      </div>
      {/* End Google Map */}
    </div>
  );
}
